import type { ArchbaseRemoteApiClient } from '@archbase/data';
import { injectable, inject } from 'inversify';
import { ARCHBASE_IOC_API_TYPE } from '@archbase/core';

export interface SystemStatus {
  service: string;
  version: string;
  status: string;
  timestamp: string;
}

@injectable()
export class RouteXDashboardService {
  constructor(@inject(ARCHBASE_IOC_API_TYPE.ApiClient) private client: ArchbaseRemoteApiClient) {}

  async getStatus(): Promise<SystemStatus> {
    return this.client.get('/api/v1/status');
  }
}
